<template>
<section>
  <v-row justify="center">
    <v-col cols="12">
      <v-progress-linear
        v-model="value"
        :size="70"
        width="7"
        :color="color"
        :indeterminate="error"
      ></v-progress-linear>
    </v-col>
  </v-row>
  <v-row>
    <v-col cols="12" class="text-center">
      <h3>Your manifest is being processed.</h3>
    </v-col>
    <v-col cols="12" class="text-center">
      <h4>Step: {{messageStep}}</h4>
    </v-col>
  </v-row>


</section>



</template>

<script>
  import axios from 'axios'

  // @vuese
  // First step of uploading a manifest
  // @group Manifest
  export default {
    name: "ManifestChecker",
    props: {
      active: Boolean,
      jobId: String,
    },
    data() {
      return {
        manifestChecked: false,
        color: 'blue darken-1',
        value: 0,
        error: false,
        messageStep: '',
        requestLoop: null,
      }
    },
    methods: {
      // @vuese
      // Gets the status of the manifest upload through the API. We call this function every 0.5s starting
      // from the moment the component is mounted
      checkManifest() {
        if (!this.manifestChecked && this.active) {
          axios.get(process.env.API_URL + '/manifests/' + this.jobId + '/status')
            .then((response) => {
              if (response.data.status === 1) {
                this.value = 33;
                this.messageStep = 'Your manifest has been queued';
              }
              if (response.data.status === 2) {
                this.value = 66;
                this.messageStep = 'Your manifest is being processed';
                if (response.data.message !== null) {
                  this.messageStep = response.data.message;
                }
              }
              if (response.data.status === 3) {
                this.value = 100;
                this.messageStep = 'Your manifest has been checked';
                this.manifestChecked = true;
                clearInterval(this.requestLoop);
                // @vuese
                // Event emitted when API returns a code saying that manifest has been checked.
                this.$emit('manifest-checked')
              }
              if (response.data.status === 4) {
                this.value = 0;
                this.error = true;
                this.color = 'red';
                this.messageStep = 'An error has occured when uploading your manifest'
                clearInterval(this.requestLoop);
              }
            })
            .catch((response) => {
              console.log(response);
              // Displays an alert
              this.$emit('alert', 'ERROR ' + response.response.data.error);
              clearInterval(this.requestLoop);
            })
        }
      },
      // @vuese
      // Starts a request loop
      checkLoop() {
        this.requestLoop = setInterval(this.checkManifest, 1500);
      }
    },
    mounted() {
      this.checkLoop();
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Manifest/ManifestChecker.vue